import { render, staticRenderFns } from "./service-seaway.vue?vue&type=template&id=125bc4b1&"
import script from "./service-seaway.vue?vue&type=script&lang=js&"
export * from "./service-seaway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports